import React from 'react';
import { Stack, Typography, CircularProgress, Button, Box } from '@mui/joy';
import MeetingCard from './MeetingCard';

interface MeetingsListProps {
  meetings: any[];
  loading: boolean;
  error: string | null;
  page: number;
  hasMore: boolean;
  onLoadMore: () => void;
  onMeetingClick: (meeting: any) => void;
}

const MeetingsList: React.FC<MeetingsListProps> = ({
  meetings,
  loading,
  error,
  page,
  hasMore,
  onLoadMore,
  onMeetingClick
}) => {
  if (loading && page === 1) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="danger" sx={{ mb: 2 }}>
        {error}
      </Typography>
    );
  }

  if (meetings.length === 0) {
    return (
      <Typography level="body-md" sx={{ color: '#7B7F85' }}>
        No meetings to display.
      </Typography>
    );
  }

      return (
      <Stack spacing={3}>
        {meetings.map(meeting => (
          <MeetingCard 
            key={meeting.id} 
            meeting={meeting} 
            onClick={() => onMeetingClick(meeting)}
          />
        ))}
      
      {hasMore && !loading && (
        <Button onClick={onLoadMore} variant="outlined" sx={{ mt: 2 }}>
          Load More
        </Button>
      )}
      
      {loading && page > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
          <CircularProgress size="sm" />
        </Box>
      )}
    </Stack>
  );
};

export default MeetingsList; 